/*
 * File: OrdersApp.js
 * Project: mp-mobile-app
 *
 * Created by Rob Rothe
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Handles displaying the orders view when the orders option is selected from the side bar
 */
import React from "react";
import Router from "components/Router";
import Routes from "./Routes";

const OrdersApp = () => {
  return <Router routes={Routes} />;
};

export default OrdersApp;
